import { gql } from 'apollo-angular';

export const IsMarketplaceStripeAccountVerifiedDocument = gql`
  query isMarketplaceStripeAccountVerified {
    isMarketplaceStripeAccountVerified
  }
`;
